import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHeartRateComponent } from "./med-icon-heart-rate.component";

@NgModule({
  declarations: [
    MedIconHeartRateComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHeartRateComponent,
  ],
})
export class MedIconHeartRateModule { }
